var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"teaching-catalo-discussion"},[_c('div',{staticClass:"teaching-catalo-discussion-head"},[_c('span',{staticStyle:{"font-weight":"bold"},domProps:{"innerHTML":_vm._s(_vm.title)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }